/**
 * Universal Intake — ambient-capture wiring constants + the pure global-drop
 * decision (INTAKE-PRD §2.8.3, slice U-E). Kept in a React-free `.ts` module so
 * both the global drop layer and the dock share ONE event name, and the entry
 * gate can test the guard without a DOM.
 */

/** The event the global drop layer dispatches and the dock listens for. */
export const INTAKE_CAPTURE_EVENT = "excellent:intake-capture";

/** Rejection ceiling — a bigger file goes through the CLI (`excellent-mcp ingest`). */
export const GLOBAL_DROP_MAX_BYTES = 10 * 1024 * 1024;

/** The `{fileName, text}` payload the capture event carries. */
export interface IntakeCaptureDetail {
  fileName: string;
  text: string;
}

/**
 * Pure decision: given whether a drag carries files and whether it started over
 * an explicit intake drop zone, should the global overlay show? The guard keeps
 * the window-level layer from fighting an inner drop target (§2.8.3) and ignores
 * non-file (text/element) drags.
 */
export function shouldShowGlobalOverlay(opts: {
  hasFiles: boolean;
  overExplicitDropZone: boolean;
}): boolean {
  return opts.hasFiles && !opts.overExplicitDropZone;
}
